// extracted by mini-css-extract-plugin
export default {"header-link":"HeaderLink_header-link__bnPRZ","active-border":"HeaderLink_active-border__YIIQi","dark-label":"HeaderLink_dark-label__vPjfZ"};